'use client';

import React from 'react';
import { useUi } from '@weareconceptstudio/core';

//* Components
import Page from '../Page';
import Footer from '../Footer';
import ScrollWrapper from '../ScrollWrapper';
import OrientationPopup from '../OrientationPopup';

const HighOrderComponent = ({ children, isFooter, isMobileScreen, isHomePortfolio }) => {
	const { isMobile } = useUi();

	return (
		<>
			{isHomePortfolio || isMobileScreen ? (
				<>
					<Page>{children}</Page>
					{isFooter && <Footer />}
				</>
			) : (
				<ScrollWrapper>
					<Page>{children}</Page>
					{isFooter && <Footer />}
				</ScrollWrapper>
			)}

			{isMobile ? <OrientationPopup /> : null}
		</>
	);
};

export default HighOrderComponent;
